import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

const TextareaContainer = styled.textarea`
  padding: ${theme.spacing.s};
  background: ${theme.colors.bgInput};
  border: none;
  border-radius: ${theme.surface.borderRadius};
  resize: none;
  box-sizing: border-box;
  font-family: ${theme.fontStyles.family};
  font-size: ${theme.fontSizes.base};
  outline: none;
  &::placeholder {
    color: ${theme.colors.placeholder};
    opacity: 0.7;
  }

  &:focus {
    outline: 1px solid ${theme.colors.gray400};
  }
`;

const Textarea = ({ placeholder, width, height, value, ...props }) => {
  const textareaSize = {
    width,
    height,
  };

  return (
    <TextareaContainer
      value={value}
      placeholder={placeholder}
      {...props}
      style={{ ...textareaSize, ...props.style }}
    />
  );
};

Textarea.propTypes = {
  placeholder: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
};

Textarea.defaultProps = {
  placeholder: '질문을 입력해주세요.',
  width: '100%',
  height: '100px',
  style: {},
  value: '',
};

export default Textarea;
